import { cloneDeepWith } from "lodash-es";
export function cloneDeepDepth(obj, depth) {
  const customizer = (value, index, obj, stack) => {
    if (stack && stack.size > depth) {
      return value;
    }
  };
  return cloneDeepWith(obj, customizer);
}